import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomOwnerField } from './CustomOwnerField';

export const CustomOwnerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomOwnerField',
    component: CustomOwnerField,
  }),
);
